// extracted by mini-css-extract-plugin
module.exports = {"select":"ProductQuantityDropdown_select__3aQf9","selectPanel":"ProductQuantityDropdown_selectPanel__zDAg1"};